import React, { useContext } from 'react';
import { AppContext } from '../../contexts/global';
import { validateDirectivas, modulesAddToken, changeUrl } from '../../utils/utils';
import './styles.scss';

export default function Modules({ slice }) {
  const items = slice.items;
  const { user, directivas } = useContext(AppContext);
  const accesosComercialRaw = slice?.primary?.accesos_comercial?.raw;
  
  const hasModules = items && items.length > 0 && items.some(item => item.link?.url && validateDirectivas(directivas, item.id));

  const groupedItems = items.reduce((acc, item) => {
    if (!item.link?.url || !validateDirectivas(directivas, item.id)) {
      return acc;
    }

    const groupKey = item.titulo_grupo?.trim() || '__no_group__';
    const groupDirectiva = item.directiva_grupo?.trim() || null;

    if (!acc[groupKey]) {
      acc[groupKey] = {
        titulo: item.titulo_grupo?.trim() || null,
        directiva: groupDirectiva,
        items: []
      };
    }

    acc[groupKey].items.push(item);
    return acc;
  }, {});

  const visibleGroups = Object.entries(groupedItems).reduce((acc, [groupKey, group]) => {
    if (group.directiva && !validateDirectivas(directivas, group.directiva)) {
      return acc;
    }
    
    if (group.items?.length > 0) {
      acc[groupKey] = group;
    }
    
    return acc;
  }, {});

  const renderModuleItem = (item, keyPrefix) => {
    const itemUrl = item.id === 'modulo.edukando' 
      ? process.env.URL_BASE_EDUKANDO_LABTICA_AUTH 
      : item.link.url;

    return (
      <a
        id={item.id}
        key={keyPrefix}
        href={itemUrl}
        rel="noopener noreferrer"
        className='modules-item'
        target='_blank'
        onClick={(event) => {
          event.preventDefault();
          
          if (modulesAddToken.includes(item.id)) {
            changeUrl(event, itemUrl, item.id, user);
          } else {
            window.open(item.link.url, '_blank');
          }
        }}
      >
        <div className='modules-item-content'>
          <div
            className='modules-item-icon'
            style={{ backgroundColor: item.color }}
          >
            <em className={`fa-solid fa-${item.icon}`} />
          </div>
          <div className='modules-item-title'>
            {item.module}
          </div>
        </div>
        <div className='modules-item-actions'>
          Ver más
        </div>
      </a>
    );
  };

  return (
    <>
      {hasModules && (
        <>
          {accesosComercialRaw && Array.isArray(accesosComercialRaw) && (
            <section className='modules comercial-slice'>
              <div className="section-title left">
                {accesosComercialRaw.map((item, index) => (
                  <React.Fragment key={index}>
                    {item.type === 'heading5' && <h5>{item.text}</h5>}
                  </React.Fragment>
                ))}
              </div>
              {items.map((item, index) => 
                item.link?.url && validateDirectivas(directivas, item.id) && 
                renderModuleItem(item, `module-${index}`)
              )}
            </section>
          )}

          {!accesosComercialRaw && Object.entries(visibleGroups).map(([groupKey, group]) => (
            <section key={groupKey} className='modules comercial-slice'>
              {group.titulo && (
                <div className="section-title left">
                  <h5>{group.titulo}</h5>
                </div>
              )}
              
              {group.items.map((item, index) => 
                renderModuleItem(item, `module-${groupKey}-${index}`)
              )}
            </section>
          ))}
        </>
      )}
    </>
  );
}